module.exports = __webpack_public_path__ + "static/media/29DUNON10.fb27d562.jpg";